// extracted by mini-css-extract-plugin
export default {"container":"qa_container__WJEVT"};